import { Component, Input, OnChanges, TemplateRef } from '@angular/core';
import { HistoryListProperty } from '@app/core/model/historyListPropertyInput';
import { PaginationService } from '@app/core/service/pagination.service';
import { OfferStateService } from '@app/ui/offer/offer-state.service';
import { stringify } from 'querystring';

@Component({
  selector: 'app-history-mobile-list',
  templateUrl: './history-mobile-list.component.html',
  styleUrls: ['./history-mobile-list.component.scss'],
})
export class HistoryMobileListComponent implements OnChanges {
  @Input()
  public objects: any[];
  @Input()
  public properties: HistoryListProperty[];
  @Input()
  public actionTemplate?: TemplateRef<any>;
  @Input()
  public titleProperty: string;
  @Input()
  public limit: number;
  @Input()
  public titleTemplate?: TemplateRef<any>;
  @Input()
  public subtitleTemplate?: TemplateRef<any>;

  public page = 1;
  public paginatedObjects: any[];

  constructor(private paginationService: PaginationService, public offerState: OfferStateService) {}

  ngOnChanges(): void {
    // We need to reset page on limit change
    this.onPageChange(1);
  }

   /**
   * Fonction pour récupérer les produits à afficher suivant la page sélectionnée
   * @param page
   */
   public paginate(page: number): void {
    let sortedProducts = JSON.parse(JSON.stringify(this.objects));

    var pageNumberMax = (sortedProducts?.length / this.offerState?.limit);
    if (this.offerState.page < page && page <= pageNumberMax + 1) {
      
      this.paginatedObjects = this.paginatedObjects?.concat(this.paginationService.getElements(sortedProducts, page, this.offerState.limit));
    }
    else {
      this.paginatedObjects = this.paginationService.getElements(sortedProducts, 1, 20);
    }
  }

  public onPageChange(page: number): void {
    let sortedProducts = JSON.parse(JSON.stringify(this.objects));
    var pageNumberMax = (sortedProducts.length / this.offerState.limit);
    if (page >= pageNumberMax + 1)
      return;
    this.paginate(page);
    this.offerState.setPage(page);

   /*  this.page = page;
    this.paginatedObjects = this.paginationService.getElements(
      this.objects,
      this.page,
      this.limit * (this.page + 1)
    ); */
  }

  scrollUp() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onScrollUp() {
    this.offerState.setPage(1);
    return;
  }
}
